import { render, staticRenderFns } from "./choujiang.vue?vue&type=template&id=6f6741e4&"
import script from "./choujiang.vue?vue&type=script&lang=js&"
export * from "./choujiang.vue?vue&type=script&lang=js&"
import style0 from "./choujiang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports